import { graphql, useStaticQuery } from 'gatsby'

export const useRetreatQuery = () =>
  useStaticQuery(graphql`
    query {
      allSanityRetreat {
        nodes {
          _id
          title
          slug {
            current
          }
          detailsCard
          _rawDescription
          popular
          dates {
            spaces
          }
          hosts {
            image {
              asset {
                _id
              }
              crop {
                _key
                _type
                top
                bottom
                left
                right
              }
              hotspot {
                _key
                _type
                x
                y
                height
                width
              }
              alt
            }
          }
          bgImg {
            asset {
              _id
            }
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            alt
          }
          gallery {
            images {
              featured
              asset {
                _id
              }
              crop {
                _key
                _type
                top
                bottom
                left
                right
              }
              hotspot {
                _key
                _type
                x
                y
                height
                width
              }
              alt
            }
          }
        }
      }
    }
  `)
